<template>
  <section class="reconfigure-solution" v-if="selectedVehicle && solutionItem">
    <div
      class="header"
      :class="{ expanded: displayFilters }"
      @click="displayFilters = !displayFilters"
    >
      <div class="container">
        <h6>{{ label_reconfigure_solution_title }}</h6>
      </div>
    </div>
    <div class="filters" v-show="displayFilters">
      <div class="container">
        <div class="row">
          
          <div class="col-md-6">
               <label for>1. {{ solutionCategories.type_text }}</label>
                <select name id v-on:change="categorySelected($event)">
                      <option>-- select --</option>
                     <option
                      v-for="(category, index) in solutionCategories.categories"
                      :value="category.categoryId"
                      :key="category.categoryId"
                    >{{ category.title }}</option>
                </select>
          </div>

          <reconfigureItem
            v-for="(item, index) in specifications"
            v-bind:key="item.key"
            v-bind:item="item"
            v-bind:index="index"
            v-bind:data="specificationData[index]"
            v-on:selection="valueSelection(index, $event)"
            :id="'step' + index "
            label_select="label_select"
          ></reconfigureItem>
        </div>         
        <div class="solutions" v-if="products.length" style="padding:0px;">
            <div class="container" style="padding:0px;">
              <div class="steps">       
                <reconfigureProduct
                  v-bind:step_count="maxStep()"
                  v-if="products"
                  v-bind:product_items="products"
                  id="step_products"
                  :currency_suffix="currency_suffix"
                  :int_curr_symbol="int_curr_symbol"
                  :label_products="label_products"
                ></reconfigureProduct>
              </div>
            </div>
          </div>
        <div class="row">
          <hr />
        </div>
        <div class="row">         
          <div class="col-md-12 button">
            <button class="btn btn-hover btn-primary" v-on:click="getProductData()">Apply filters</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import reconfigureItem from "./reconfigure-solution-item";
import reconfigureProduct from "./reconfigure-solution-product";

export default {
  name: "reconfigure-solution",
  data() {
    return {
      displayFilters: false,
      categoryId : null,
      solutionItem: [],
      solutionCategories : [],
      specifications: [],
      selectedSpecifications: [],
      specificationData: [],
      products: []
    };
  },
  props: {
        product: {
            type: String,
            required: true
        },
        currency_suffix: {
          type: String,
          default: "(RRP inc GST)"
        },
        label_reconfigure_solution_title: {
          type: String,
          required: true,
          default: "Reconfigure your Roof Rack solution"
        },
        int_curr_symbol: {
          type: String,
          default: "AUD"
        },
      label_products: {
          type: String,
          required: true,
          default: "Products"
      },
      label_select: {
          type: String,
          required: true,
          default: "select"
      }
    },
  mounted() {
    this.loadSolution();
  },  
  computed: {
    platformTypes() {
      return this.$store.state.platformTypes;
    },
    sizes() {
      return this.$store.state.sizes;
    },
    selectedVehicle() {
      return this.$store.state.solutions.selectedVehicle.vehicleId;
    },
  },
  components: {
    reconfigureItem,
    reconfigureProduct
  },
  methods :{
    maxStep() {
      if (this.products.length == 0) {
        return this.specifications.length + 2;
      } else {
        return this.specificationData.length + 2;
      }
    },

     async loadSolution() {
      let solutionItemsResponse = await axios.get(
        `api/solutions/product/${this.product}/vehicle/${this.selectedVehicle}`
      );
      this.solutionItem = solutionItemsResponse.data.data.solutionItemId;
      this.solutionCategories = solutionItemsResponse.data.data;
      this.specifications = solutionItemsResponse.data.data.specifications;
    },

     async getData() {
      var specifications = this.specifications;

      // create data to send
      let data = {
        categoryId: this.categoryId,
        results: false
      };

      if(specifications)
      for (var i = 0; i < specifications.length; i++) {
        if (this.selectedSpecifications.length > i) {
          data[specifications[i].key] = this.selectedSpecifications[i];
        } else {
          data[specifications[i].key] = "null";
        }
      }

      // request data from api
      let response = await axios.post(
        `api/solutions/item/${this.solutionItem}/vehicle/${this.selectedVehicle}`, data);     

      this.specificationData[this.selectedSpecifications.length] =
        response.data.data.items;
      this.specificationData = this.specificationData.slice(
        0,
        this.selectedSpecifications.length + 1
      );      
    },

    categorySelected($event) {
      this.categoryId = $event.target.value;
      this.selectedSpecifications = [];
      this.specificationData = [];
      this.products = [];      
      this.getData();      
    },

     valueSelection(index, $event) {
       this.selectedSpecifications[index] = $event.target.value
       this.selectedSpecifications = this.selectedSpecifications.slice(
         0,
         index + 1
       );
       this.products = [];

      var load_products = false;

      for (var i = 0; i < this.specificationData[index].length; i++) {
        if (
          this.specificationData[index][i].specificationPropertyMasterDataId ===
            $event &&
          this.specificationData[index][i].product_count == 1
        ) {
          load_products = true;
        }
      }

      // if (this.selectedSpecifications.length == this.specifications.length) {
      //   load_products = true;
      // }

      if (load_products) {
        this.getProductData();        
      } else {
        this.getData();        
      }
    },
     // Load the list of products
    async getProductData() {
      this.products = [];

      // create data to send
      let data = {
        categoryId: this.categoryId,
        results: true
      };

      for (var i = 0; i < this.specifications.length; i++) {
        if (this.selectedSpecifications.length > i) {
          data[this.specifications[i].key] = this.selectedSpecifications[i];
        } else {
          data[this.specifications[i].key] = "null";
        }
      }

      // request data from api
  
      let response = await axios.post(`api/solutions/item/${this.solutionItem}/vehicle/${this.selectedVehicle}`, data);

      this.products = response.data.data.items;
    },
  }
};
</script>
